<div [style.display]="isVisible() ? 'flex' : 'none'" class="item-container date-input-container">
  <label
    [for]="htmlId()"
    [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']"
    [style]="getTextStyle()"
    [title]="getTextTitle()">
    {{ properties.text }}
  </label>
  <div class="second-column">
    <input
      [id]="htmlId()"
      [type]="properties.inputType"
      [formControl]="formControl!"
      [style]="inputStyle()"
      (change)="onDateChange($event)" />

    <button
      type="button"
      class="today-button"
      [disabled]="formControl?.disabled"
      (click)="onSetTodayClick($event)"
      [title]="translateService.instant('liveforms-editor.date-input-item.tooltips.set-today')">
      {{ translateService.instant('liveforms-editor.date-input-item.buttons.today') }}
    </button>

    <button
      type="button"
      (click)="onClearDateClick($event)"
      [disabled]="formControl?.disabled || !formControl?.value"
      class="clear-button"
      [title]="translateService.instant('liveforms-editor.date-input-item.tooltips.clear')">
      <div class="icon-safe-zone">
        <mat-icon>delete</mat-icon>
      </div>
    </button>
  </div>
</div>
